import * as Api from "../../api";
import { ThunkDispatch } from "redux-thunk";
import { TRootState } from "../reducers/RootReducer";
import { Action } from "redux";
import { TApiSubsetOptions } from "../../api/endpoints/SubsetOption";

export const SUBSET_OPTION_FETCH_COMPLETED = 'SUBSET_OPTION_FETCH_COMPLETED';

export interface IFetchSubsetOptionsCompletedAction {
  type: typeof SUBSET_OPTION_FETCH_COMPLETED;
  subsetId: number,
  options: TApiSubsetOptions
}

const fetchSubsetOptionsCompleted = (subsetId: number, options: TApiSubsetOptions) => ({
  type: SUBSET_OPTION_FETCH_COMPLETED,
  subsetId,
  options
})

const fetchSubsetOptions = (subsetId: number) => {
  return async (dispatch: ThunkDispatch<TRootState, void, Action>): Promise<TApiSubsetOptions> => {
    try {
      const options = await Api.SubsetOption.fetch(subsetId);

      dispatch(fetchSubsetOptionsCompleted(subsetId, options));

      return options;
    } catch (error) {
      throw error;
    }
  }
}

export {
  fetchSubsetOptions
}
